import React from 'react';
import { shape, string } from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import SingleCasePage from '../../templates/SingleCasePage';
import data from '../../data/cases/inspospotr';
import nextCaseData from '../../data/cases/polar';
import InfoColumnSection from '../../components/InfoColumnSection';
import TitleAndBodySection from '../../components/case/TitleAndBodySection';
import SingleImage from '../../components/case/SingleImage';
import ContainerNoFrame from '../../components/case/ContainerNoFrame';

import variables from '../../styles/variables.module.scss';

const nextCase = {
  title: nextCaseData.title,
  path: nextCaseData.path,
  footerImg: nextCaseData.case,
  color: nextCaseData.color,
  isWeb: nextCaseData.isWeb,
};

const InspospotrCasePage = ({ location }) => (
  <SingleCasePage
    location={location}
    caseName={data.key}
    data={data}
    nextCase={nextCase}
    quoteData={data.quoteData}
    alignHeroImage="center"
  >
    <Container>
      <Grid container direction="column">
        {
          data.titleBodyData[0] && (
            <TitleAndBodySection
              title={data.titleBodyData[0].title}
              body={data.titleBodyData[0].body}
              justify={data.titleBodyData[1] ? 'flex-end' : 'flex-start'}
            />
          )
        }
      </Grid>
    </Container>
    {
      data.xtra && (
        <ContainerNoFrame images={data.xtra} />
      )
    }
    {
      data.infoTitle && data.infoBody && (
        <Grid item>
          <InfoColumnSection
            headlineSmall={data.title}
            backgroundColor={variables.carbonBlack}
            title={data.infoTitle}
            body={data.infoBody}
            isCase
          />
        </Grid>
      )
    }
    {
      data.footerBanner && (
        <SingleImage
          image={data.footerBanner}
          isAndroid={data.isAndroid}
          style={{ width: '100%', margin: 0 }}
        />
      )
    }
  </SingleCasePage>
);

InspospotrCasePage.propTypes = {
  location: shape({
    pathname: string,
  }).isRequired,
};

export default InspospotrCasePage;
